import React from 'react';

function Factories() {
  return (
    <section className="page factories">
      <h2>Our Factories</h2>
      <p>
        We have two production units specializing in different product ranges:
      </p>
      <div>
        <h3>Sai Sena Impex (Knitted Garments)</h3>
        <p>T-shirts, shorts, rompers, body suits, pants, etc.</p>
      </div>
      <div>
        <h3>Sai Textiles (Technical Textiles)</h3>
        <p>Workwear, medical scrubs, FRC suits, and more.</p>
      </div>
    </section>
  );
}

export default Factories;
